import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faUndo,
  faPrint,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import * as Highcharts from "highcharts";

@Component({
  selector: "app-piensosgrf",
  templateUrl: "./piensosgrf.component.html",
  styleUrls: ["./piensosgrf.component.css"],
})
export class PiensosgrfComponent implements OnInit {
  datosTabla: any = [{}];

  lineaGrafico: typeof Highcharts = Highcharts;
  tartaGrafico: typeof Highcharts = Highcharts;

  opcionesLinea: Highcharts.Options = {
    chart: {
      type: "line",
    },
    title: {
      text: "Producción de uva en kilogramos",
    },
    subtitle: {
      text: "",
    },
    yAxis: {
      title: {
        text: "kilogramos",
      },
    },
    xAxis: {
      categories: ["2021"],
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle",
    },
    series: [
      { name: "", type: undefined, data: [0] },
      { name: "", type: undefined, data: [0] },
      { name: "", type: undefined, data: [0] },
    ],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 400,
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
            },
          },
        },
      ],
    },
  };

  opcionesTarta: Highcharts.Options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
    },
    title: {
      text: "Totales Producción",
    },
    subtitle: {
      text: "",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f} %",
        },
      },
    },
    series: [
      {
        name: "Kg",
        colorByPoint: true,
        type: undefined,
        data: [],
      },
    ],
  };

  datEjex: any;

  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoRet = faUndo;
  icoPrn = faPrint;
  icoFac = faFileAlt;

  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  resul: boolean;

  prifec: string;
  ultfec: string;

  SwGrf0: boolean;
  SwGrf1: boolean;
  SwGrf2: boolean;
  SwGrf3: boolean;
  SwGrf4: boolean;

  SwLinGr: boolean;
  SwTarGr: boolean;

  constructor(
    private srvCentral: CentralService,
    private modalService: NgbModal,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    /* Cargo tabla de menús */
    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }
    this.SwLinGr = false;
    this.SwTarGr = true;
    this.SwGrf4 = true;

    this.prifec = this.srvCentral.fechaCadena(this.srvCentral.gnPriDia);
    this.ultfec = this.srvCentral.fechaCadena(this.srvCentral.gnUltDia);
    //this.cargaDatos();
  }

  persiana(): void {
    $("#wrapper").toggleClass("toggled");
  }

  tipoGraf(md: number): void {
    if (md === 0) {
      this.graficoCero();
    }
    if (md === 1) {
      this.graficoUno();
    }
    if (md === 2) {
      this.graficoDos();
    }
    if (md === 3) {
      this.graficoTres();
    }
    if (md === 4) {
      this.graficoCuatro();
    }
  }

  // cargaDatos() {
  //   this.resul = true;
  //   this.datosTabla = [];
  //   this.datEjex = [];
  //   this.srvCentral.entregacord(0, 2, this.prifec, this.ultfec)
  //       .subscribe(datos => {
  //         if (datos[0].enFecha === '?') {
  //           this.resul = false;
  //           const modalRef = this.modalService.open(AvisosComponent);
  //           modalRef.componentInstance.datAviso = {tit: 'ERROR SERVIDOR',
  //                                                  tex: datos[0].enUva,
  //                                                  tip: 2,
  //                                                  btcan: '',
  //                                                  btno: '',
  //                                                  btsi: 'Aceptar'};
  //           modalRef.result.then((result) => {
  //           });

  //         } else {
  //              this.resul = false;
  //              this.datosTabla = [];
  //              for (const regis of datos) {
  //                   const tx = this.srvCentral.saca(regis.enUva);
  //                   regis.enUva = tx;
  //                   this.datosTabla.push(regis);
  //              }
  //              this.preparaEjex();
  //              this.graficoCuatro();
  //         }
  //   });

  // }

  volver(): void {
    this.router.navigate(["/piensos"]);
  }

  preparaEjex(): void {
    this.datEjex = [];
    for (const dato of this.datosTabla) {
      // const nano = parseInt(dato.enFecha, 10);
      const inx = this.datEjex.indexOf(dato.enFecha);
      if (inx === -1) {
        this.datEjex.push(dato.enFecha);
      }
    }
    this.datEjex.sort();
  }
  buscaEjex(nano: string): number {
    const inx = this.datEjex.indexOf(nano);
    return inx;
  }

  preparaSerie(): any {
    const tmptab = [];
    for (const item of this.datEjex) {
      tmptab.push(0);
    }
    return tmptab;
  }

  graficoCero() {
    this.SwLinGr = true;
    this.SwTarGr = false;

    const datser = [];
    let datos = [];
    let nomuva = "@@@***@@@";

    for (const dato of this.datosTabla) {
      const uva = dato.enUva;
      if (uva !== nomuva) {
        if (nomuva !== "@@@***@@@") {
          // cargo el dato
          const yser = { name: nomuva, type: undefined, data: datos };
          datser.push(yser);
        }
        nomuva = uva;
        datos = this.preparaSerie();
      }
      const inx = this.buscaEjex(dato.enFecha);
      if (inx > -1) {
        datos[inx] = parseFloat(dato.enKil);
      }
    }
    if (nomuva !== "@@@***@@@") {
      // cargo la última vuelta del for
      const yser = { name: nomuva, type: undefined, data: datos };
      datser.push(yser);
    }

    if (datser.length > 15) {
      this.reduccionQ(datser);
    }

    this.opcionesLinea = {
      chart: {
        type: "line",
      },
      title: {
        text: "Producción Uva en kilogramos",
      },
      subtitle: {
        text: "Desde:" + this.prifec + " Hasta:" + this.ultfec,
      },
      yAxis: {
        title: {
          text: "kilogramos",
        },
      },
      xAxis: {
        categories: this.datEjex,
      },
      legend: {
        layout: "vertical",
        align: "right",
        verticalAlign: "middle",
      },
      series: datser,
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 400,
            },
            chartOptions: {
              legend: {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
              },
            },
          },
        ],
      },
    };
  }

  graficoUno() {
    this.SwLinGr = true;
    this.SwTarGr = false;

    const datser = [];
    let datos = [];
    let nomuva = "@@@***@@@";

    for (const dato of this.datosTabla) {
      const uva = dato.enUva;
      if (uva !== nomuva) {
        if (nomuva !== "@@@***@@@") {
          // cargo el dato
          const yser = { name: nomuva, type: undefined, data: datos };
          datser.push(yser);
        }
        nomuva = uva;
        datos = this.preparaSerie();
      }
      const inx = this.buscaEjex(dato.enFecha);
      if (inx > -1) {
        let precio = "0";
        const impor = parseFloat(dato.enImp);
        const hecto = parseFloat(dato.enHgr);
        if (hecto !== 0) {
          const vpre = impor / hecto;
          precio = vpre.toFixed(3);
        }
        datos[inx] = parseFloat(precio);
      }
    }
    if (nomuva !== "@@@***@@@") {
      // cargo la última vuelta del for
      const yser = { name: nomuva, type: undefined, data: datos };
      datser.push(yser);
    }

    if (datser.length > 15) {
      this.reduccionQ(datser);
    }
    console.log(datser);
    this.opcionesLinea = {
      chart: {
        type: "line",
      },
      title: {
        text: "Precios de Uva",
      },
      subtitle: {
        text: "Desde:" + this.prifec + " Hasta:" + this.ultfec,
      },
      yAxis: {
        title: {
          text: "Precios",
        },
      },
      xAxis: {
        categories: this.datEjex,
      },
      legend: {
        layout: "vertical",
        align: "right",
        verticalAlign: "middle",
      },
      series: datser,
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 400,
            },
            chartOptions: {
              legend: {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
              },
            },
          },
        ],
      },
    };
  }

  graficoDos() {
    this.SwLinGr = true;
    this.SwTarGr = false;

    const datser = [];
    let datos = [];
    let nomuva = "@@@***@@@";

    for (const dato of this.datosTabla) {
      const uva = dato.enUva;
      if (uva !== nomuva) {
        if (nomuva !== "@@@***@@@") {
          // cargo el dato
          const yser = { name: nomuva, type: undefined, data: datos };
          datser.push(yser);
        }
        nomuva = uva;
        datos = this.preparaSerie();
      }
      const inx = this.buscaEjex(dato.enFecha);
      if (inx > -1) {
        datos[inx] = parseFloat(dato.enImp);
      }
    }
    if (nomuva !== "@@@***@@@") {
      // cargo la última vuelta del for
      const yser = { name: nomuva, type: undefined, data: datos };
      datser.push(yser);
    }

    if (datser.length > 15) {
      this.reduccionQ(datser);
    }

    this.opcionesLinea = {
      chart: {
        type: "line",
      },
      title: {
        text: "Importes",
      },
      subtitle: {
        text: "Desde:" + this.prifec + " Hasta:" + this.ultfec,
      },
      yAxis: {
        title: {
          text: "Importes",
        },
      },
      xAxis: {
        categories: this.datEjex,
      },
      legend: {
        layout: "vertical",
        align: "right",
        verticalAlign: "middle",
      },
      series: datser,
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 400,
            },
            chartOptions: {
              legend: {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
              },
            },
          },
        ],
      },
    };
  }

  graficoTres() {
    this.SwLinGr = false;
    this.SwTarGr = true;

    const datser = [];
    let sumas = 0;
    let nomuva = "@@@***@@@";

    for (const dato of this.datosTabla) {
      const uva = dato.enUva;
      if (uva !== nomuva) {
        if (nomuva !== "@@@***@@@") {
          // cargo el dato
          const tsum = parseFloat(sumas.toFixed(2));
          const yser = { name: nomuva, y: tsum };
          datser.push(yser);
        }
        nomuva = uva;
        sumas = 0;
      }
      const inx = this.buscaEjex(dato.enFecha);
      if (inx > -1) {
        const num = parseFloat(dato.enKil);
        sumas = sumas + num;
      }
    }
    if (nomuva !== "@@@***@@@") {
      // cargo la última vuelta del for
      const tsum = parseFloat(sumas.toFixed(2));
      const yser = { name: nomuva, y: tsum };
      datser.push(yser);
    }

    if (datser.length > 15) {
      this.reduccionQ(datser);
    }

    this.opcionesTarta = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
      },
      title: {
        text: "Totales Producción",
      },
      subtitle: {
        text: "Desde:" + this.prifec + " Hasta:" + this.ultfec,
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b>: {point.percentage:.1f} %",
          },
        },
      },
      series: [
        {
          name: "Kg",
          colorByPoint: true,
          type: undefined,
          data: datser,
        },
      ],
    };
  }
  graficoCuatro() {
    this.SwLinGr = false;
    this.SwTarGr = true;

    const datser = [];
    let sumas = 0;
    let nomuva = "@@@***@@@";

    for (const dato of this.datosTabla) {
      const uva = dato.enUva;
      if (uva !== nomuva) {
        if (nomuva !== "@@@***@@@") {
          // cargo el dato
          const tsum = parseFloat(sumas.toFixed(2));
          const yser = { name: nomuva, y: tsum };
          datser.push(yser);
        }
        nomuva = uva;
        sumas = 0;
      }
      const inx = this.buscaEjex(dato.enFecha);
      if (inx > -1) {
        const num = parseFloat(dato.enImp);
        sumas = sumas + num;
      }
    }
    if (nomuva !== "@@@***@@@") {
      // cargo la última vuelta del for
      const tsum = parseFloat(sumas.toFixed(2));
      const yser = { name: nomuva, y: tsum };
      datser.push(yser);
    }

    if (datser.length > 15) {
      this.reduccionQ(datser);
    }

    this.opcionesTarta = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie",
      },
      title: {
        text: "Totales Importes",
      },
      subtitle: {
        text: "Desde:" + this.prifec + " Hasta:" + this.ultfec,
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: "<b>{point.name}</b>: {point.percentage:.1f} %",
          },
        },
      },
      series: [
        {
          name: "€",
          colorByPoint: true,
          type: undefined,
          data: datser,
        },
      ],
    };
  }

  reduccionQ(entra) {
    // alert('Pendiente de ajustar a 15');
  }
}
